/**
 * FlitoCRM tracking: page views, who the visitor is, and the site's events go
 * into the CRM.
 *
 * Set at build time in frontend/.env:
 *   REACT_APP_FLITO_SITE_KEY   the site key from the CRM, Settings > Website
 *   REACT_APP_FLITO_ENDPOINT   the CRM address (https://1000c.flitocrm.com by default)
 * Without a site key nothing loads and every call does nothing.
 *
 * Every Mixpanel event is sent here too (utils/mixpanel.js), so the CRM's
 * alerts and website reports get them as they happen.
 */

const SITE_KEY = process.env.REACT_APP_FLITO_SITE_KEY || '';
const ENDPOINT = (process.env.REACT_APP_FLITO_ENDPOINT || 'https://1000c.flitocrm.com').replace(/\/+$/, '');

let started = false;

const flito = (...args) => {
  if (!SITE_KEY || typeof window === 'undefined') return;
  window.flitoq = window.flitoq || [];
  window.flito = window.flito || function queue() {
    window.flitoq.push(arguments);
  };
  window.flito(...args);
};

/** Load the tracker once. spa: true records a page view on every route change. */
export const startFlito = () => {
  if (started || !SITE_KEY || typeof document === 'undefined') return;
  started = true;
  flito('init', { siteKey: SITE_KEY, endpoint: ENDPOINT, spa: true });
  const script = document.createElement('script');
  script.async = true;
  script.src = `${ENDPOINT}/flito-tracker.js`;
  document.head.appendChild(script);
};

/** On login and sign-up: ties this browser's visits to the contact. */
export const identify = (user) => {
  if (!user || !user.email) return;
  flito('identify', {
    email: user.email,
    ...(user.firstName ? { firstName: user.firstName } : {}),
    ...(user.lastName ? { lastName: user.lastName } : {}),
  });
};

export const track = (name, properties = {}) => flito('track', name, properties);

/** On logout. */
export const reset = () => flito('reset');

export const trackRegistration = (email) => {
  identify({ email });
  track('User Registration', { email, registrationMethod: 'email' });
};

export const trackProductFavorite = (productId, productName, productType, action = 'add') => {
  track(action === 'remove' ? 'Product Unfavorited' : 'Product Favorited', {
    productId,
    productName,
    productType,
  });
};

export const trackAlertCreated = (alertType, productType, criteria = {}) => {
  track('Product Alert Created', { alertType, productType, ...criteria });
};
